import { useEffect, useState } from 'react';
import { ChatWidgetAPI } from '../services/api';

const AWAITING_CHATS_REFRESH_MS = 60 * 1000;
// Fired after a staff reply or take/release so the badge updates at once.
export const CHATS_CHANGED_EVENT = 'aiker:chats-changed';

// Website chats waiting for a person to reply (W-H): nav badge, same polling as the callback
// badge — on load, every minute while visible, on focus and right after a reply. Stops on
// 401/403 (no service-records access) and 404 (a backend without the route).
export const useAwaitingChatCount = (enabled = true) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!enabled) { setCount(0); return undefined; }
    let live = true;
    let stopped = false;
    const refresh = () => {
      if (stopped || (typeof document !== 'undefined' && document.visibilityState === 'hidden')) return;
      Promise.resolve().then(() => ChatWidgetAPI.awaitingCount())
        .then((data) => { if (live) setCount(Math.max(0, Number(data?.count) || 0)); })
        .catch((error) => {
          const status = error?.response?.status;
          if (status === 401 || status === 403 || status === 404) stopped = true;
        });
    };
    refresh();
    const timer = setInterval(refresh, AWAITING_CHATS_REFRESH_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') refresh(); };
    window.addEventListener('focus', refresh);
    window.addEventListener(CHATS_CHANGED_EVENT, refresh);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      live = false;
      clearInterval(timer);
      window.removeEventListener('focus', refresh);
      window.removeEventListener(CHATS_CHANGED_EVENT, refresh);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [enabled]);
  return count;
};

export const announceChatsChanged = () => {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(CHATS_CHANGED_EVENT));
};

export default useAwaitingChatCount;
